import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../accordion/accordion';
import { FormattedMessage, injectIntl } from 'react-intl';
import { DrinkAlcoholic } from '../../icons';
import { EVENT_FAQ_CONST, EVENT_FAQ_ANSWERS_CONST } from '../data/constants';
import { eventFaqDefinition, category_labels } from '../data/eventFaqDefinition';

const AlcoholContent = ({ faqData, alcoholRule, moreAlcoholRules, hasMoreInformationRules, hasCrossedOutRules, moreInformation, crossedOutRules, intl }) => {
  const { BRING_ALCOHOL_ALLOWED, BRING_ALCOHOL_NOT_ALLOWED } = EVENT_FAQ_ANSWERS_CONST;
  const { OTHER_ALCOHOL_CONSUMPTION_RULES } = EVENT_FAQ_CONST;
  const label = <FormattedMessage
    id={category_labels.alcohol.id}
    defaultMessage={category_labels.alcohol.defaultMessage}
  />;
  return (
    <div className="EventFAQ">
      <Accordion
        header={
          <div className="flex middle">
            <DrinkAlcoholic height={24} width={24} className="margin-sm-right" />
            <div className="h6 margin-md-left padding-xs-top padding-xs-bottom faq-section">{label}</div>
          </div>
        }
        onOpenCallback={() => {
          analyticsIntegrations.trackEvent('Listing section expanded', {
            user_id: faqData.userID,
            listing_id: faqData.listingID,
            section: 'Alcohol'
          });
        }}
      >
        <div className='margin-lg-bottom section-indent event-faq-section'>
          <div className="faq-label heavier margin-sm-bottom">
            {intl.formatMessage(eventFaqDefinition.alcohol_beverages.bring_alcohol[alcoholRule])}
          </div>
          {BRING_ALCOHOL_ALLOWED === alcoholRule &&
            <div className="text-gray-600 description margin-md-bottom">
              {intl.formatMessage(eventFaqDefinition.alcohol_beverages.bring_alcohol_rules[moreInformation])}
            </div>
          }
          {moreAlcoholRules
            && <div>
              {hasMoreInformationRules && moreInformation.map((rule, key) => (
                <div className="description margin-md-bottom" key={key}>
                  {intl.formatMessage(eventFaqDefinition.alcohol_beverages.alcohol_consumption_options[rule])}
                </div>))}
              {
                faqData[OTHER_ALCOHOL_CONSUMPTION_RULES] && BRING_ALCOHOL_NOT_ALLOWED === alcoholRule
                && <>
                  <div className="description">
                    {intl.formatMessage(eventFaqDefinition.alcohol_beverages.alcohol_consumption_options[OTHER_ALCOHOL_CONSUMPTION_RULES])}
                  </div>
                  <div className="text-gray-600 description margin-md-bottom">{faqData[OTHER_ALCOHOL_CONSUMPTION_RULES]}</div>
                </>
              }
              {hasCrossedOutRules && crossedOutRules.map((rule, key) => (
                <div className="text-gray-500 description strike-through margin-md-bottom" key={key}>
                  {intl.formatMessage(eventFaqDefinition.alcohol_beverages.alcohol_consumption_options[rule])}
                </div>))}
            </div>}
        </div>
      </Accordion>
    </div>
  );
};

AlcoholContent.propTypes = {
  faqData: PropTypes.object,
  intl: PropTypes.object,
  alcoholRule: PropTypes.string,
  moreAlcoholRules: PropTypes.bool,
  hasMoreInformationRules: PropTypes.bool,
  hasCrossedOutRules: PropTypes.bool,
  moreInformation: PropTypes.array,
  crossedOutRules: PropTypes.array
};

export default injectIntl(AlcoholContent);
